module.exports = __webpack_public_path__ + "media/images/salespartner/problem04-f333cb58ac44205de74a3449da2ddd9c.svg";